import { render, staticRenderFns } from "./color-toggle-button.vue?vue&type=template&id=5b0ea053&scoped=true"
import script from "./color-toggle-button.vue?vue&type=script&lang=js"
export * from "./color-toggle-button.vue?vue&type=script&lang=js"
import style0 from "./color-toggle-button.vue?vue&type=style&index=0&id=5b0ea053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ea053",
  null
  
)

export default component.exports